<template>
  <div>
    <b-breadcrumb :items="crumbLinks"></b-breadcrumb>
    <div class="d-flex">
      <h2>{{ pageTitle }}</h2>
      <b-link
        :href="rssLink"
        target="_blank"
        v-b-tooltip.hover
        title="Subscribe to RSS Feed"
        class="ml-2"
        aria-label="Subscribe to RSS Feed"
      >
        <i class="fas fa-rss" aria-hidden="true"></i>
      </b-link>
    </div>
    <div class="items-panel">
      <div v-for="(item, i) in news" :key="i" class="news-item" :id="item.id">
        <h3
          v-html="item.title + ' [' + item.date + ']'"
          class="news-header"
        ></h3>
        <div v-html="item.content"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCurrFullNews } from "@/services/NewsService";

export default {
  name: "BreakingNews",
  data() {
    return {
      pageTitle: "Breaking News",
      news: [],
      crumbLinks: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "News",
          href: "/news/overview",
        },
        {
          text: "Breaking News",
          active: true,
        },
      ],
      rssLink: `${process.env.VUE_APP_API_BASE_URL}/news/breakingnews/rss`,
    };
  },
  async mounted() {
    try {
      const response = await this.fetchNews();
      this.news = response; // Update state with fetched data
      // Scroll to hash after data is loaded and DOM is updated
      await this.$nextTick();
      if (this.$route.hash) {
        const id = this.$route.hash.slice(1);
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      }
    } catch (error) {
      console.error("Error fetching news:", error);
    }
  },
  methods: {
    async fetchNews() {
      return await getCurrFullNews();
    },
  },
};
</script>

<style scoped lang="scss"></style>
